import { Component, OnInit } from "@angular/core";
import { RemoteConfigModule } from "@angular/fire/remote-config";
import { RouterOutlet } from "@angular/router";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [RouterOutlet, RemoteConfigModule],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent implements OnInit {
  title = "Cladded Glass Broadband";

  constructor() {}

  ngOnInit(): void {}
}
